import SectionHeader from "@components/SectionHeader";
import forYou01 from "./img/for-you-desktop.png";
import forOther01 from "./img/for-other-desktop.png";
import forYou02 from "./img/for-you-desktop2.png";
import forOther02 from "./img/for-other-desktop2.png";
import "./style.scss";
import DOMPurify from "dompurify";

const cardContent = [
  {
    header: "",
    thumbnail: forYou01,
    mobileThumbnail: forYou01,
    thumbnail2: forYou02,
    mobileThumbnail2: forYou02,
    desc: "Für Dich",
    list: [
      `<strong>100 Punkte im Inspiration Club</strong>`,
      `<strong>15€ Wunschgutschein per E-Mail </strong>`,
    ],
    list2: [
      `<strong>100 Punkte im Inspiration Club</strong>`,
      `<strong>15€ Rabattgutschein für vuse.com per E-Mail </strong>`,
    ],
    des: ``,
    listColor: "#3D65AB",
  },
  {
    header: "",
    thumbnail: forOther01,
    mobileThumbnail: forOther01,
    thumbnail2: forOther02,
    mobileThumbnail2: forOther02,
    desc: "Für deinen Freund",
    list: [`<strong>-10€ für den ersten Kauf eines glo™ Heaters*</strong>`],
    list2: [`<strong>15€ Rabatt für den ersten Einkauf auf vuse.com*</strong>`],
    des: `*Dein Freund muss sich über den von dir angegebenen Link im glo™-Shop registrieren. Der Rabatt wird beim Kauf des Geräts an der Kasse automatisch angewendet.`,
    des2: `Nach erfolgreicher Registrierung bekommt dein/e Freund/in automatisch im Warenkorb einen 15 € Gutschein für unseren Onlineshop.
Der Rabatt kann innerhalb von 3 Monaten nach Erhalt und ab einem Mindestbestellwert von 25 € eingelöst werden und ist nur für volljährige Kund:innen verfügbar. Der Rabattcode kann einmalig angewendet werden und ist nicht mit anderen Rabatten kombinierbar.  Der Versand des Gutscheins erfolgt innerhalb von 14 Tagen nach Nutzung des Einladungslinks.`,
    listColor: "#3D65AB",
  },
];

export default function Benefits({ content }) {
  return (
    <div className="recommend-page-benefits">
      <SectionHeader>
        <strong>Vorteile</strong>
      </SectionHeader>
      <div className="card-wrapper">
        {cardContent.map((card, i) => (
          <div key={i}>
            <div className="benefits-card">
              <picture>
                <source
                  media="(max-width: 768px)"
                  srcSet={
                    content !== "/invite/vuse"
                      ? card.mobileThumbnail
                      : card.mobileThumbnail2
                  }
                />

                <source
                  media="(min-width: 769px)"
                  srcSet={
                    content !== "/invite/vuse"
                      ? card.thumbnail
                      : card.thumbnail2
                  }
                />

                <img
                  className="thumbnail"
                  src={
                    content !== "/invite/vuse"
                      ? card.thumbnail
                      : card.thumbnail2
                  }
                  alt={card.desc}
                />
              </picture>
              <div className="inner">
                <h3 className="title">{card.desc}</h3>
                <span className="desc">{card.header}</span>
                <ul className="list">
                  {(content !== "/invite/vuse" ? card.list : card.list2).map(
                    (listItem, i) => (
                      <li key={i} className="list-item">
                        <div className="list-content">
                          <p
                            style={{
                              color: card.listColor,
                            }}
                            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(listItem)}}
                            className="list-desc"
                          />
                        </div>
                      </li>
                    )
                  )}
                </ul>
                <p className="des">
                  {content !== "/invite/vuse" ? card.des : card.des2}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
